import React from "react"
import './index.css'

function FakeCategoryTitle() {
    return (
        <div id="fake-category-title"/>
    )
}

export { FakeCategoryTitle }